import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Heading, Button, Box } from '@wix/design-system';
import s from './Enterprise.scss';
import { EnterpriseRefContext } from 'providers/EnterpriseContextProvider';
import EnterpriseImage from '../../../assets/images/enterprise/enterprise_visual.svg';
import { useBreakpoint } from 'providers/BreakpointProvider';
import { MediaDevices } from 'enums';

export const EnterpriseHeader: React.FC = () => {
  const { t } = useTranslation();
  const { currentBreakpoint } = useBreakpoint();

  const { scrollToRef } = React.useContext(EnterpriseRefContext);

  return (
    <Box className={s.headerContainer}>
      <Box className={s.headerInnerContainer}>
        <Heading
          className={s.headerTitle}
          appearance='H2'
          dataHook='enterprise-tab-title'
        >
          {t('enterprise_plans.body.header_no_price')}
        </Heading>
        <Text className={s.headerSubtitle}>
          {t('enterprise_plans.body.text')}
        </Text>
        <Box>
          <Button
            dataHook='enterprise-tab-request-call-btn'
            size='large'
            className={s.headerButton}
            onClick={() => scrollToRef()}
          >
            {t('enterprise_plans.button.request_a_call')}
          </Button>
        </Box>
      </Box>
      {currentBreakpoint === MediaDevices.Desktop && <EnterpriseImage />}
    </Box>
  );
};
